<template>
  <div class="info-item" v-if="programs.length > 0" :class="{pd: !flag}">
    <div class="head">
      <template v-if="!flag">
        {{$ml.get(`Programs`)}}
      </template>
      <div v-else @click="$emit('resetFlag')" class="back">
        <svg width="7" height="15" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.83749 14.0013C5.68809 14.0018 5.54048 13.9688 5.4055 13.9048C5.27052 13.8407 5.15161 13.7473 5.05749 13.6313L0.227488 7.63125C0.0804062 7.45232 0 7.22788 0 6.99625C0 6.76463 0.0804062 6.54018 0.227488 6.36125L5.22749 0.361252C5.39723 0.157036 5.64114 0.0286112 5.90556 0.0042315C6.16999 -0.0201482 6.43327 0.0615137 6.63749 0.231252C6.8417 0.400991 6.97013 0.644902 6.99451 0.909329C7.01889 1.17375 6.93723 1.43704 6.76749 1.64125L2.29749 7.00125L6.61749 12.3613C6.73977 12.508 6.81745 12.6868 6.84133 12.8763C6.86521 13.0659 6.83429 13.2583 6.75223 13.4308C6.67018 13.6034 6.54042 13.7488 6.37831 13.8499C6.2162 13.9509 6.02852 14.0035 5.83749 14.0013Z" fill="#448833"/>
        </svg>
        {{$ml.get(`Back`)}}
      </div>
      <SearchInput v-model="search"/>
    </div>
    <div class="list">
      <div class="headList">
        <div>
          {{$ml.get(`PROGRAM NAME`)}}
        </div>
        <div>
          {{$ml.get(`CREATION DATE`)}}
        </div>
        <div>
          {{$ml.get(`CROPS IN USE`)}}
        </div>
        <div>
          {{$ml.get(`FIELD / FARM`)}}
        </div>
        <div class="smoll">

        </div>
      </div>
      <div v-if="flagW" class="table">
        <div v-for="item in true_data" :key="item.id">
          <div>
            <template v-if="item.name != null">
              {{item.name}}
            </template>
            <template v-else>
              -
            </template>
          </div>
          <div>
            <template v-if="item.created_at != null">
              {{item.created_at}}
            </template>
            <template v-else>
              -
            </template>
          </div>
          <div>
            <template v-if="item.cropName != null">
              {{item.cropName}}
            </template>
            <template v-else>
              -
            </template>
          </div>
          <div>
            <template v-if="item.fieldName != null && item.farmName != null">
              {{item.fieldName}} / {{item.farmName}}
            </template>
            <template v-else>
              -
            </template>
          </div>
          <div class="smoll">
            <svg width="13" height="16" viewBox="0 0 13 16" fill="none" @click="download(item.id, item.name)" v-if="item.programIsFinished">
              <path d="M8 0H1.6C1.17565 0 0.768687 0.168571 0.468629 0.468629C0.168571 0.768687 0 1.17565 0 1.6V14.4C0 14.8243 0.168571 15.2313 0.468629 15.5314C0.768687 15.8314 1.17565 16 1.6 16H11.2C11.6243 16 12.0313 15.8314 12.3314 15.5314C12.6314 15.2313 12.8 14.8243 12.8 14.4V4.8L8 0ZM4.3984 11.352C4.1512 11.584 3.7864 11.688 3.3616 11.688C3.27923 11.6889 3.1969 11.6841 3.1152 11.6736V12.8144H2.4V9.6656C2.72276 9.61745 3.0489 9.59551 3.3752 9.6C3.8208 9.6 4.1376 9.6848 4.3512 9.8552C4.5544 10.0168 4.692 10.2816 4.692 10.5936C4.6912 10.9072 4.5872 11.172 4.3984 11.352ZM7.444 12.436C7.108 12.7152 6.5968 12.848 5.972 12.848C5.5976 12.848 5.3328 12.824 5.1528 12.8V9.6664C5.47568 9.61927 5.80171 9.59707 6.128 9.6C6.7336 9.6 7.1272 9.7088 7.4344 9.9408C7.7664 10.1872 7.9744 10.58 7.9744 11.144C7.9744 11.7544 7.7512 12.176 7.444 12.436ZM10.4 10.216H9.1744V10.9448H10.32V11.532H9.1744V12.8152H8.4496V9.624H10.4V10.216ZM8 5.6H7.2V1.6L11.2 5.6H8Z" fill="$mainGreen"/>
            </svg>

            <svg width="13" height="16" viewBox="0 0 13 16" fill="none" @click="deleteProgram(item.id)">
              <path d="M8.10667 6.64L6.22222 8.52444L4.32889 6.64L3.07556 7.89333L4.96889 9.77778L3.08444 11.6622L4.33778 12.9156L6.22222 11.0311L8.10667 12.9156L9.36 11.6622L7.47556 9.77778L9.36 7.89333L8.10667 6.64ZM9.33333 0.888889L8.44444 0H4L3.11111 0.888889H0V2.66667H12.4444V0.888889H9.33333ZM0.888889 14.2222C0.888889 15.2 1.68889 16 2.66667 16H9.77778C10.7556 16 11.5556 15.2 11.5556 14.2222V3.55556H0.888889V14.2222ZM2.66667 5.33333H9.77778V14.2222H2.66667V5.33333Z" fill="#FF585E"/>
            </svg>
          </div>
        </div>
      </div>
      <div v-else class="car">
        <carousel :pageCustom="pageCustom">
          <template v-for="item in true_data">
            <div class="row">
              <div>
                <template v-if="item.name != null">
                  {{item.name}}
                </template>
                <template v-else>
                  -
                </template>
              </div>
              <div>
                <template v-if="item.created_at != null">
                  {{item.created_at}}
                </template>
                <template v-else>
                  -
                </template>
              </div>
              <div>
                <template v-if="item.cropName != null">
                  {{item.cropName}}
                </template>
                <template v-else>
                  -
                </template>
              </div>
              <div>
                <template v-if="item.fieldName != null && item.farmName != null">
                  {{item.fieldName}} / {{item.farmName}}
                </template>
                <template v-else>
                  -
                </template>
              </div>
              <div class="smoll">
                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" @click="download(item.id, item.name)" v-if="item.programIsFinished">
                  <path d="M8 0H1.6C1.17565 0 0.768687 0.168571 0.468629 0.468629C0.168571 0.768687 0 1.17565 0 1.6V14.4C0 14.8243 0.168571 15.2313 0.468629 15.5314C0.768687 15.8314 1.17565 16 1.6 16H11.2C11.6243 16 12.0313 15.8314 12.3314 15.5314C12.6314 15.2313 12.8 14.8243 12.8 14.4V4.8L8 0ZM4.3984 11.352C4.1512 11.584 3.7864 11.688 3.3616 11.688C3.27923 11.6889 3.1969 11.6841 3.1152 11.6736V12.8144H2.4V9.6656C2.72276 9.61745 3.0489 9.59551 3.3752 9.6C3.8208 9.6 4.1376 9.6848 4.3512 9.8552C4.5544 10.0168 4.692 10.2816 4.692 10.5936C4.6912 10.9072 4.5872 11.172 4.3984 11.352ZM7.444 12.436C7.108 12.7152 6.5968 12.848 5.972 12.848C5.5976 12.848 5.3328 12.824 5.1528 12.8V9.6664C5.47568 9.61927 5.80171 9.59707 6.128 9.6C6.7336 9.6 7.1272 9.7088 7.4344 9.9408C7.7664 10.1872 7.9744 10.58 7.9744 11.144C7.9744 11.7544 7.7512 12.176 7.444 12.436ZM10.4 10.216H9.1744V10.9448H10.32V11.532H9.1744V12.8152H8.4496V9.624H10.4V10.216ZM8 5.6H7.2V1.6L11.2 5.6H8Z" fill="$mainGreen"/>
                </svg>

                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" @click="deleteProgram(item.id)">
                  <path d="M8.10667 6.64L6.22222 8.52444L4.32889 6.64L3.07556 7.89333L4.96889 9.77778L3.08444 11.6622L4.33778 12.9156L6.22222 11.0311L8.10667 12.9156L9.36 11.6622L7.47556 9.77778L9.36 7.89333L8.10667 6.64ZM9.33333 0.888889L8.44444 0H4L3.11111 0.888889H0V2.66667H12.4444V0.888889H9.33333ZM0.888889 14.2222C0.888889 15.2 1.68889 16 2.66667 16H9.77778C10.7556 16 11.5556 15.2 11.5556 14.2222V3.55556H0.888889V14.2222ZM2.66667 5.33333H9.77778V14.2222H2.66667V5.33333Z" fill="#FF585E"/>
                </svg>
              </div>
            </div>
          </template>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import SearchInput from '@/components/common/SearchInput'
import Carousel from '@/components/common/carousel/Carousel';

export default {
  props: {
    flag: {
      type: Boolean
    }
  },
  data () {
    return {
      search: '',
      pageCustom: [
        [0, 1],
        [660, 2],
        [760, 1],
      ],
      flagW: true
    }
  },
  created () {
    if (window.innerWidth <= 950) {
      this.flagW = false;
    }
  },
  computed: {
    ...mapGetters({
      pdfs: 'subAccount/pdfs',
      programs: 'subAccount/programs',
    }),
    true_data () {
      var res = this.programs;
      
      res.map(item => {
        var pdf = this.pdfs.find(itemPdf => itemPdf.programId == item.id);

        if (pdf)
          item.programIsFinished = true;
      });

      if (this.search != '')
        res = res.filter(item => {
          if (item.name.indexOf(this.search) != -1)
            return true;
          
          return false
        });

      if (!this.flag)
        return res.slice(0, 3);

      return res;
    }
  },
  methods: {
    async download (programId, name) {
      var pdf = this.pdfs.find(itemPdf => itemPdf.programId == programId);

      var result = await API.pdf.getPdfById(pdf.id);
      var blob = new Blob([result.data], {type: 'application/pdf'});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      if(!name) {
        name = 'report';
      }
        link.download = name + '.pdf';
      link.click();
    },
    deleteProgram (programId) {
      API.subAccounts.deleteProgram(programId).then(res => {
        this.$store.dispatch('subAccount/getPrograms');
      });
    }
  },
  components: {
    SearchInput,
    Carousel
  }
}
</script>

<style lang="scss" scoped>
  .info-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    
    &.pd {
      padding-bottom: 40px;
    }

    .head {
      width: 100%;
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 22px;
      color: #4C5056;
      padding-bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 560px) {
        flex-direction: column;
        
        > div {
          margin-top: 20px;
        }
      }

      .back {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        color: #747579;
        cursor: pointer;
        display: flex;
        align-items: center;

        svg {
          margin-right: 9px;
        }
      }
    }

    .list {
      width: 100%;
      display: flex;
      flex-direction: column;

      @media (max-width: 900px) {
        flex-direction: row;
      }

      > .table {
        width: 100%;

        > div {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          border-bottom: 0.7px solid #E4E5E6;
          padding: 0 30px;
          height: 66px;

          > div {
            width: 100%;
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            color: #4C5056;
            text-transform: capitalize;

            &.smoll {
              width: 30px;
              min-width: 30px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              
              svg:first-child {
                margin-right: 5px;
              }

              svg:hover path {
                fill: #C4C4C4;
              }
            }
          }
        }

      }
      .headList {
        height: 33px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-bottom: 0.7px solid #E4E5E6;
        padding: 0 30px;


        @media (max-width: 900px) {
          min-width: 200px;
          width: 200px;
          height: auto;
          align-items: stretch;
          flex-direction: column;
          border: none;
          padding: 0;
          border-right: 0.7px solid #E4E5E6;
        }
        @media (max-width: 450px) {
          min-width: 140px;
          width: 140px;
        }

        > div {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          letter-spacing: 0.05em;
          color: #8B8D91;
          width: 100%;

          @media (max-width: 900px) {
            height: 64px;
            border-bottom: 0.7px solid #E4E5E6;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          @media (min-width: 900px) {
            &.smoll {
              width: 30px;
              min-width: 30px;
            }
          }
        }
      }
      .car {
        width: calc(100% - 200px);

        @media (max-width: 450px) {
          width: calc(100% - 140px);
        }

        .row {
          display: flex;
          flex-direction: column;
          width: 100%;

          div {
            width: 100%;
            height: 64px;
            border-bottom: 0.7px solid #E4E5E6;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;

            &:first-child {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
</style>
